export default "__VITE_ASSET__CoHW0Nj6__";